import { render } from "./ViewResetPassword.vue?vue&type=template&id=074e8cc2&scoped=true"
import script from "./ViewResetPassword.vue?vue&type=script&lang=js"
export * from "./ViewResetPassword.vue?vue&type=script&lang=js"

import "@/css/views/view-reset-password.css?vue&type=style&index=0&id=074e8cc2&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074e8cc2"]])

export default __exports__